import type {
    Category,
    Template,
    TemplateCollection
} from "@/content/templates/template.types";

import { LoaderMatchers } from "../../loader-matcher";

export type TemplatePageMetadata = {
    title?: string | null;
    description?: string | null;
    titleSuffix?: "template" | "collection";
};

export type GetTemplateMetadataProps = {
    route: string;
    templates?: Template[];
    collections?: TemplateCollection[];
    categories?: Category[];
};

export const getTemplateMetadata = ({
    route,
    templates,
    collections,
    categories
}: GetTemplateMetadataProps): TemplatePageMetadata | undefined => {
    const matcher = Object.values(LoaderMatchers).find((loader) =>
        loader.match.test(route)
    );

    if (!matcher) {
        console.warn(`No metadata loader matcher found for route ${route}`);
        return;
    }

    const matchGroup = matcher.match.exec(route);
    let urlSlug = "";

    if (matchGroup && matchGroup.groups) {
        urlSlug = matchGroup.groups["urlSlug"] as string;
    }

    if (matcher.getPageMetadata) {
        return matcher.getPageMetadata({
            templates,
            collections,
            categories,
            urlSlug
        });
    }

    return;
};
